import * as React from "react";
import * as cn from "classnames";
import styles = require("./style.less");

interface GettingStartedDetailSectionProps {
    header: string;
    imgSrc: string;
    area: string;
    complete: boolean;
    highlightSection: boolean;
}

const GettingStartedDetailSection: React.StatelessComponent<GettingStartedDetailSectionProps> = props =>
    <span className={cn(styles.section, {[styles.pulseSection]: props.highlightSection})}>
        {props.complete && <div className={styles.complete}><em className="fa fa-check" aria-hidden="true" /></div>}
        <div className={styles.top}>
            <img src={props.imgSrc} height="50" alt={props.area} />
            <div>{props.header}</div>
            <div className={styles.area}>{props.area}</div>
        </div>
        <div className={styles.content}>
            {props.children}
        </div>
    </span>;

export default GettingStartedDetailSection;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/GettingStarted/GettingStartedDetailSection.tsx